/* eslint-disable */
import * as loadLayer from "./utils/loadLayer.js";
import analysis from './utils/tools/analysis.js'
/** 
 * 声明地图类
 */
class dy3dMap {
  constructor(){
    this._mars3d = window.mars3d
    this._cesium = window.Cesium
    this._map = null
    this._analysis = new analysis()
  }
};

/**
 * 初始化地图
 * @param {string} containerBsm 地图容器标识码
 * @param {Object} config 地图配置的json文件
 * @returns {Object} 地图对象
 */
dy3dMap.prototype.init3DMap = function (containerBsm,config) {
  this._map = new window.mars3d.Map(containerBsm,config)
  return this._map
}

/**
 * 销毁地图
 */
dy3dMap.prototype.destroyed = function (map) {
  if(map){
    map.destroyed()
    map = null
    this._map = map
  }
}
/**
 * 加载各类不同服务的图层
 * @param {Object} layerObj 图层的配置参数用于加载图层（arcgis服务只取服务节点和图层的layerId,geoserver服务取图层节点）- 从外部传进来就要做相应的区分和组装
 * @param {string} serviceType 服务类型或者一些其它自定义的类型
 * @param {Object} map 地图图数据
 */
dy3dMap.prototype.loadLayers = function (layerObj, serviceType, map) {
  switch (serviceType) {
    // 加载arcgis服务
    case 'ArcGIS Server Rest':
        loadLayer.loadArcGISLayer(layerObj,map)
      break;
    // 加载geoserver的矢量切片
    case 'TMS':
        loadLayer.loadMVTLayer(layerObj,map)
      break;
    case 'PBF':
        loadLayer.loadPBFLayer(layerObj, map);
      break;
    // 加载WMTS服务
    case 'WMTS':
        loadLayer.loadWMTSLayer(layerObj,map)
      break;
    // 加载WMS服务
    case 'WMS':
      loadLayer.loadWMSLayer(layerObj,map)
    break;
    // 加载GeoJSON
    case 'GeoJSON':
      loadLayer.loadGeoJSONLayer(layerObj,map)
    break;
    // 加载3dtiles
    case '3dTiles':
      loadLayer.load3dTilesLayer(layerObj,map)
    break;
    // 加载ArcGIS Tiles
    case 'ArcGIS Server Tile':
      loadLayer.loadArcGISTile(layerObj, map);
      break;
    // 加载XYZ
    case 'XYZ':
      loadLayer.loadXYZTile(layerObj, map);
      break;
    default:
      break;
  }
}
/**
 * 加载图层注记
 * @param {object} options 目前只使用到了options.name
 * @param {string} url 服务地址:geoserver
 * @param {object} labelStyle 传过来的注记样式解构的JSON文件
 * @param {*} map 
 */
dy3dMap.prototype.addLabels = function (options,url,labelStyle,map) {
    let extent = map.getExtent()
    let name = labelStyle.labelCode.toLowerCase()
    fetch(url + `&bbox=${extent.xmin},${extent.ymin},${extent.xmax},${extent.ymax}`).then(response=>response.json()).then(data=>{
      let pointCenter = []
      let centerArr = []
      let labelCollection = new Cesium.LabelCollection()
      labelCollection.name = options.name + '注记'
      map.scene.primitives.add(labelCollection);
      // let labels = map.scene.primitives.add(new Cesium.LabelCollection())
      // let graphicLayer = new mars3d.layer.GraphicLayer()
      // map.addLayer(graphicLayer)
      // console.log('data',data.features);
      if(data.features[0].geometry.type.includes('Polygon') || data.features[0].geometry.type.includes('MultiPolygon')){
        for(let i = 0;i<data.features.length;i++){
          let coords = data.features[i].geometry.coordinates[0]
          // let polygon = turf.polygon(coords)
          let polygon = null
          let center = null;
          coords.length && (polygon = turf.polygon(coords));
          if(polygon){
            center = turf.centroid(polygon)
            pointCenter.push(center);
          }
          let attr = data.features[i].properties[name]
          centerArr.push(attr)
         }  
         
         // let styleJSON = JSON.parse(options.layerStyle)
         let color = toRGB(labelStyle.labelColor)
        //  console.log('point and label',pointCenter,centerArr);
        //  labelSize(map.level)
     
         for(let j = 0;j<pointCenter.length;j++){
           let center = pointCenter[j].geometry.coordinates
           // const graphic = new mars3d.graphic.LabelPrimitive({
          //   name: options.name,
          //   position: new mars3d.LngLatPoint(_center[0],_center[1]),
          //   style: {
          //     text: centerArr[j],
          //     font_size: labelStyle.size,
          //     color: "#ffff00",
          //     scaleByDistance:true,
          //     scaleByDistance_far:labelStyle.maxDistance,
          //     scaleByDistance_farValue:0,
          //     scaleByDistance_near:labelStyle.minDistance,
          //     scaleByDistance_nearValue:1,
          //     clampToGround: true
          //   },
          // })
          // graphicLayer.addGraphic(graphic)
           let labelParams = {
            //  id:labelStyle.labelId,
             text:centerArr[j],
             position:new Cesium.Cartesian3.fromDegrees(center[0],center[1],0),
             font:`${labelStyle.size}px ${labelStyle.family}`,
             fillColor:new Cesium.Color(color[0]/255.0,color[1]/255.0,color[2]/255.0,1.0),
             outlineColor:Cesium.Color.BLACK, //边线好像不起作用
             outlineWidth:1.5,
             style:Cesium.LabelStyle.FILL,
            //  scaleByDistance:new Cesium.NearFarScalar(1,1,99999999,2)
             scaleByDistance:new Cesium.NearFarScalar(labelStyle.minDistance,1,labelStyle.maxDistance,0)
           };
          //  console.log('参数',labelParams);
          //  labels.add(labelParams)
          labelCollection.add(labelParams);
         }
      }else if(data.features[0].geometry.type.includes('Point')){
        let features = data.features
        let color = toRGB(labelStyle.labelColor)
        for(let i = 0;i<data.features.length;i++){
          let labelParams = {
            text:data.features[i].properties[name],
            position:new Cesium.Cartesian3.fromDegrees(features[i].geometry.coordinates[0],features[i].geometry.coordinates[1],0),
            font:`${labelStyle.size}px ${labelStyle.family}`,
            fillColor:new Cesium.Color(color[0]/255.0,color[1]/255.0,color[2]/255.0,1.0),
            scaleByDistance:new Cesium.NearFarScalar(1,1,99999999,2)
          }
          labels.add(labelParams)
        }
      }
  
    })
    function toRGB(inColor) {
      // 16进制颜色值的正则
      var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
      // 把颜色值变成小写
      var color = inColor.toLowerCase();
      if (reg.test(color)) {
        // 如果只有三位的值，需变成六位，如：#fff => #ffffff
        if (color.length === 4) {
          var colorNew = "#";
          for (var i = 1; i < 4; i += 1) {
            colorNew += color.slice(i, i + 1).concat(color.slice(i, i + 1));
          }
          color = colorNew;
        }
        // 处理六位的颜色值，转为RGB
        var colorChange = [];
        for (var i = 1; i < 7; i += 2) {
          colorChange.push(parseInt("0x" + color.slice(i, i + 2)));
        }
        return colorChange;
      } else {
        return color;
      }
    }
}
/**
 * 移除所有图层（只保留底图）
 */
dy3dMap.prototype.removeAllLayers = function (map) {
  if(map){
    let allLayers = map.getLayers()
    if(allLayers.length > 0){
      allLayers.map(item => {
        if(item.type != 'xyz'){
          map.removeLayer(item)
        }
      })
    }
  }
}

/**
 * 根据指定属性移除图层
 * @param {object} obj.map 地图数据
 * @param {string|number} obj.attrValue 属性值
 * @param {string} obj.attr 属性名
 */
dy3dMap.prototype.removeLayerByAttr = function (obj) {
  let {map, attr, attrValue} = obj
  if(map){
    let layer = map.getLayerByAttr(attrValue,attr)
    if(layer){
      map.removeLayer(layer)
    }
  }
}

/**
 * 按属性/空间范围/cql的方式进行查询（使用时获取result需要用.then的方式）
 * @param {String} serverUrl 服务查询地址（geoserver）http://192.168.1.16:9090/geoserver/wfs
 * @param {String} layerName 服务的图层组名
 * @param {Object} queryByAttr 按属性查询{column:'',text:''}
 * @param {Object} queryByGeom 按空间范围查询{graphic:graphic,geometryName:'geom'}
 * @param {String} queryBySql 按cql方式查询 cql_filter
 * @returns 
 */
dy3dMap.prototype.queryAnalaysis = function(serverUrl,layerName,queryByAttr,queryByGeom,queryBySql){
  let queryMapServer = this._analysis.initServer(serverUrl,layerName)
  let result = this._analysis.query(queryMapServer,queryByAttr,queryByGeom,queryBySql)
  return result
}

export default dy3dMap;